import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { CreateResource, ResourceSearch, FilteredResourceTable } from '../containers/index';

const propTypes = {
  setView: PropTypes.func.isRequired,
};

const ResourcesView = ({ setView }) => (
  <div className="appContainer">
    <div className="paper" id="search">
      <div>
        <CreateResource />
      </div>
      <div>
        <ResourceSearch />
      </div>
      <div>
        <Button
          content={'Edit Tags'}
          icon="edit"
          labelPosition="right"
          floated="right"
          onClick={() => {
            setView('tags');
          }}
        />
      </div>
    </div>
    <FilteredResourceTable />
  </div>
);

ResourcesView.propTypes = propTypes;
export default ResourcesView;



// WEBPACK FOOTER //
// ./src/components/ResourcesView.jsx